module.exports = __webpack_public_path__ + "media/images/landing-pages/5_to_11_year_olds_course-3e6c8b596b8c3d81453b886fb722cec1.png";